<template>
<div id="container" class="spacegeschichten">
    <div class="fullscreen_background">
        <img src="/static/assets/spacegeschichten/Hintergrund.png" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <div class="mond z30 hovering">
        <img class="img" src="/static/assets/spacegeschichten/Mond.png" />
    </div>
    <div class="mannimmond z30">
        <img class="img" src="/static/assets/spacegeschichten/Mann_im_Mond.png" />
    </div>
    <div class="libero z30 hovering">
        <img class="img" src="/static/assets/spacegeschichten/Libero.png" />
    </div>
    <div class="hugi z30">
        <img class="img" src="/static/assets/spacegeschichten/Hugi.png" />
    </div>
    <div class="dubix z30">
        <img class="img" src="/static/assets/spacegeschichten/Dubix.png" />
    </div>
	<div class="gigi z30">
        <img class="img" src="/static/assets/spacegeschichten/Gigi.png" />
    </div>
	
	<div class="roboterklein z30">
        <img class="img" src="/static/assets/spacegeschichten/Roboter.png" />
    </div>
	<div class="raketenfrau z30">
        <img class="img" src="/static/assets/spacegeschichten/Erdpraesidentin.png" />
    </div>
    <div class="sterne sterne_animation z29">
    </div>
	<div class="roboter z30 roboter_animation" v-bind:class="{roboter_animation:animateRoboter}" v-on:click="aktiviereRoboter">
    </div>
	<div class="planet planet_animation z30">
    </div>
	<div class="rakete z29 rakete_erscheint"> 
		<img class="img hovering3" src="/static/assets/spacegeschichten/Rakete.png" />
    </div>
    <router-link to="/junglegeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil.png" />
    </router-link>

    <router-link to="/wassergeschichten" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/spacegeschichten/Geschichte.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichte_1_Sternenritter_Dubix.mp3" jsonurl="/static/assets/geschichten/dubix_19_3.timings.json" content=".spacegeschichten" target="spacegeschichten_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="spacegeschichten_target">
<p>Der Weltraum — unendliche Weiten. Wir schreiben das Jahr 3999. Dies ist ein Abenteuer des Raumschiffs Luna 3. Die Astronauten Commander Gigi, Hugi Solo und Laikan Libero waren unterwegs in wichtiger Mission. Sie mussten die Erde retten, denn der Mond, der ihr seit Jahrmillionen in der Nacht Licht gespendet und über die Gezeiten geherrscht hatte, schien nicht mehr. Sein einziger Bewohner, der Mann im Mond, wollte ihn nicht mehr zum Leuchten bringen! Ohweh! Die Lage auf der Erde war verzweifelt, wie sollte sie ohne den Mond auskommen? Also sandte die Erdpräsidentin Neila ihre mutigsten Astronauten aus. Sie sollten alle Weisen der Galaxis um Rat bitten. Überall wurden sie freundlich empfangen, doch nirgendwo wusste ein Weiser Rat. Nur auf ihrer letzten Station, in der Wolkenstadt Aristophane, hatte ihnen die uralte Königin Lea zugeraunt: „Geht nach Epiblem, dort wohnt der Sternenritter Dubix. Er ist hunderte von Jahren alt und weiß viel. Vielleicht kann er euch helfen.“ </p>
<p>„Epiblem? Wo liegt das denn?“ Hugi Solo hatte noch nie von diesem Planeten gehört. Gut, dass das Navigationsgerät der Luna 3 ihn kannte. Nicht einmal einen Landeplatz hatte dieser winzige Planet! Also parkten sie ihr Raumschiff im Weltraum, beamten sich auf Epiblem und landeten – platsch – inmitten eines Sumpfes! Wie sollten sie hier Sternenritter Dubix finden? Sie mussten ihn nicht suchen. „Ich erwartet euch schon habe“, sagte plötzlich ein gelbes Männchen. „Die Erde Hilfe braucht. Ich spüre.“ </p>
<p>Er führte sie in sein minikleines Häuschen, trocknete ihre Kleider, kochte Tee und reichte Laikan Libero eine Schale mit Wasser. „Kennt Ihr den Mann im Mond?“, fragte ihn Hugi Solo hoffnungsvoll.  „Ja, seit langer Zeit“, antwortete Sternenritter Dubix. „So wisst Ihr, warum er den Mond nicht mehr scheinen lässt?“ fragte Hugi Solo weiter. „Vermuten ich nur kann“, erwiderte der Sternenritter Dubix, „schon einmal es passiert, vor 500 Jahren. Damals sein Büchervorrat ausgegangen ist.“ „Wie konnte das passieren? Der Bücherstern strahlt doch immer und sendet über seine Beamlines Bücher an alle Planeten“, warf Commander Gigi ungläubig ein. „Versperrt die Beamline war. Ein Raumschiffwrack im Weg.“ „Es konnten also keine Bücher mehr vom Bücherstern zum Mann im Mond gebeamt werden?“, fragte Hugi Solo. Sternenritter Dubix nickte bedächtig: „Kein Buch führt zu Trauer, Trauer führt zu Dunkelheit.“ „Danke, Sternenritter Dubix!“, rief Commander Gigi, „das ist die Lösung: der viele Weltraummüll, sicher versperrt er die Beamline zum Mond. Wir müssen die Milchstraße aufräumen!“</p>
<p>Wenige Wochen später schien der Mond wieder sanft auf die Erde und der Mann im Mond las sogar bei seinem täglichen Mondspaziergang. Die Aktion Spaceputz aber war noch im vollen Gange. Die Bewohner aller Planeten halfen mit und setzten ihre besten Roboter ein. Selbst der Gewinner der intergalaktischen Robotik-Olympiade, R9D9, war dabei. Bald war die Milchstraße blitzblank und niemand musste mehr um die Bücher-Beamline zu seinem Planeten fürchten. Denn wer will schon ohne Bücher leben, wo doch jedes Kind in jeder Galaxie ganz genau weiß:</p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Junglegeschichten',
  data () {
    return {
      who: 'Junglegeschichten',
      animateRoboter: false
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar, 
    'hintergrundbutton': Hintergrundbutton
  },
  watch: { 
    animateRoboter: function (oldval, newval) {
      console.log('watch animateRoboter', oldval, newval)
    }
  },
  methods: {
    aktiviereRoboter () {
      console.log('aktiviereRoboter')
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = undefined
        } catch(e) {
          console.log('pause geht nicht', e)
        }
      }
      window.currentAudioV = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Tanzender_Roboter_Update.mp3')
      window.currentAudioV.muted = window.muted
      window.currentAudioV.play()
      this.animateRoboter = true
      var self = this
      setTimeout(function () {
        console.log('aktiviereRoboter2')
        self.animateRoboter = false
      }, 3000)
    }
  },
  mounted () {
    this.$ga.page(this.$router)  
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Dubix_Titel_Sternenritter.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Sternenritter_Atmo.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false) 
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }  
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* spacegeschichten */
.spacegeschichten { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.spacegeschichten .himmel { display: block !important; }

.spacegeschichten .geschichte { position: absolute; top: 170px; left:51%;  }

.spacegeschichten .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.spacegeschichten .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

/* .spacegeschichten .schwimmer {position: absolute; left: 28%; top: 39%; } */
.spacegeschichten .schwimmer {position: absolute; left: 25%; top: 12%; }
.spacegeschichten .schwimmer img{animation: schwimmer_erscheint 3s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; margin-left: -870px;}
@keyframes schwimmer_erscheint {
    0% {margin-left: -870px; opacity:0;}
    25% { opacity:1;}
    100% {margin-left: 0px; opacity:1;}
}
.spacegeschichten .baer {position: absolute; /* left: 36%; top: 74%; */ left: 37%; bottom: 4%; }
.spacegeschichten .baer {animation: baer_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-bottom: -270px; */}
@keyframes baer_erscheint {
    /* 50% {margin-bottom: -270px; transform: scale(0.5); opacity:0;}
    100% {margin-bottom: 0px; transform: scale(1); opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.spacegeschichten .raketenfrau {position: absolute;     bottom: 480px;
    left: 39.5%;}
.spacegeschichten .koechin {position: absolute; left: 37%; bottom: 26%;}
.spacegeschichten .hugi {position: absolute; left: 38%; bottom: 17%;}
.spacegeschichten .hugi {animation: hugi_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.spacegeschichten .mond {
    position: absolute;
    left: 41%;
    top: 19%;
}
.spacegeschichten .roboter {
    position: absolute;
    bottom: -18%;
    left: 28%;
    margin-top: 0px;
    width: 381px;
  height: 386px;
    background: url('/static/assets/spacegeschichten/Roboter_Animation.png') top center;
  cursor:pointer;
}
.spacegeschichten .roboterklein {position: absolute; top: 214px;
    left: 550px;}
.spacegeschichten .roboterklein {animation: roboterklein_erscheint 0.4s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes roboterklein_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.spacegeschichten .gigi {position: absolute;     bottom: 110px;
    left: 480px;}
.spacegeschichten .gigi {animation: gigi_erscheint 0.7s ease-out; animation-delay: 0.6s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes gigi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.spacegeschichten .mannimmond {position: absolute; bottom: 380px;
    left: 440px;}
.spacegeschichten .mannimmond {animation: mannimmond_erscheint 0.75s ease-out; animation-delay: 0.2s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes mannimmond_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.spacegeschichten .dubix {position: absolute; left: 14%; bottom: 12%;}
.spacegeschichten .dubix {animation: dubix_erscheint 0.7s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
	.spacegeschichten .rakete {
    position: absolute;
	top: 230px;
    left: 650px;

}
.spacegeschichten .planet {
    position: absolute;
	top: 310px;
    left: 480px;
}
.spacegeschichten .sterne {position:absolute; top: -310px; left: -340px;}
.spacegeschichten .libero {position: absolute; left: 41.5%; bottom: 79%;}
.spacegeschichten .wasserfall {position: absolute; /* left: 23%; bottom: 6%; */}
.spacegeschichten .moeve { position: absolute; top: 250px; left: 600px; }
.spacegeschichten .schild { position: absolute; bottom: 29px; left: 209px; }
.fliesstext{
    bottom: 25%;
    left: 13.5%;
    width: 71%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,20px);
    -moz-transform: translate(20px,20px);
    -webkit-transform: translate(20px,20px);
    -o-transform: translate(20px,20px);
    transform: translate(20px,20px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.spacegeschichten .hovering {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}

/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,0px);
    -moz-transform: translate(20px,0px);
    -webkit-transform: translate(20px,0px);
    -o-transform: translate(20px,0px);
    transform: translate(20px,0px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.spacegeschichten .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

.spacegeschichten .hovering3 {
  -webkit-animation: hovering 20s linear infinite;
  -moz-animation: hovering 20s linear infinite;
  -ms-animation: hovering 20s linear infinite;
  -o-animation: hovering 20s linear infinite;
  animation: hovering 20s linear infinite;
}

/* schwimmer animation */
@-webkit-keyframes hovering3 /* Safari and Chrome */ {
  0% {
    -webkit-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
  25% {
    -webkit-transform: scale(1.02);
    -o-transform: scale(1.02);
    transform: scale(1.02);
  }
  50% {
    -webkit-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
  75% {
    -webkit-transform: scale(0.98);
    -o-transform: scale(0.98);
    transform: scale(0.98);
  }
  100% {
    -webkit-transform: scale(1);
    -o-transform: scale(1);
    transform: scale(1);
  }
}

/*************** SCROLLBAR BASE CSS ***************/
 
.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}
 
.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}
 
.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}
 
.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}
 
.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}
 
.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
/*************** SIMPLE INNER SCROLLBAR ***************/
 
.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}
 
.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */
 
.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69; 
    box-shadow: inset 0 0 0px #ac8a69; 
    -webkit-border-radius: 0;
    border-radius: 0;
}
 
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69; 
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69; 
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat; 
}

.sterne_animation {
  width: 2880px;
  height: 1620px;
  background: url('/static/assets/spacegeschichten/Sterne_Animation.png') top center;
  animation-delay: 1s;
  animation: sterne_animation 2s steps(4) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes sterne_animation {
    100% { background-position: 0 -6480px; }
}
.roboter_animation {
  animation-delay: 1s;
  animation: roboter_animation 6s steps(9) infinite;
  transform: scale(1);
}

@keyframes roboter_animation {
	0% { background-position: 0 0px; }
	25% { background-position: 0 -3474px; }
    100% { background-position: 0 -3474px; }
}
.rakete_erscheint {animation: rakete_erscheint_animation 10s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes rakete_erscheint_animation {
    0% {left: 390px; top: 0px; opacity:0;}
    100% {left: 650px; top: 230px; opacity:1;}
}
.skigeschichten .seilbahn {position: absolute;
    left: 24%;
    bottom: 49%;
}
.planet_animation {
  width: 189px !important;
  height: 207px !important;
  background: url('/static/assets/spacegeschichten/Planet_Animation.png') top center;
  animation-delay: 2s;
  animation: planet_animatio 2s steps(4) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes planet_animatio {
    100% { background-position: 0 -828px; }
}
.spacegeschichten .player {position: absolute !important;left: 145px !important;}
span { font-family: FrozenMemory; }
.geschichte .player { top: 664px !important; }
.spacegeschichten .player .inner {
    left: 80px !important;
    top: 25px !important;
}
.spacegeschichten #spacegeschichten_target .current-word {
    color: #e8f5fd !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Spacegeschichten.vue